import "./featured.scss";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "react-circular-progressbar/dist/styles.css";

import {
  collection,
  onSnapshot,
} from "firebase/firestore";
import { db } from "../../../../firebase";

const Featured = () => {
  const { t } = useTranslation();
  const [candidates, setCandidates] = useState([]);
  const [examinators, setExaminators] = useState([]);
  const [posts, setPosts] = useState([]);
  const type = localStorage.getItem("type");

  useEffect(() => {

    // LISTEN (REALTIME)
    const getCandidates = onSnapshot(
      collection(db, "submissions"),
      (snapShot) => {
        let list = [];
        snapShot.docs.forEach((doc) => {
          list.push({ id: doc.id, ...doc.data() });
        });
        setCandidates(list);
      },
      (error) => {
        console.log(error);
      }
    );

    const getExaminators = onSnapshot(
      collection(db, "exam"),
      (snapShot) => {
        let list = [];
        snapShot.docs.forEach((doc) => {
          list.push({ id: doc.id, ...doc.data() });
        });
        setExaminators(list);
      },
      (error) => {
        console.log(error);
      }
    );

    const getPosts = onSnapshot(
      collection(db, "posts"),
      (snapShot) => {
        let list = [];
        snapShot.docs.forEach((doc) => {
          list.push({ id: doc.id, ...doc.data() });
        });
        setPosts(list);
      },
      (error) => {
        console.log(error);
      }
    );

    return () => {
      getCandidates();
      getExaminators();
      getPosts();
    };
  }, []);

  return (
    <div className="featured">
      <div className="top">
        <h1 className="">{t('dashboard')}</h1>
      </div>
      <div className="bottom">
                
        <div className="summary cadre p-3">
          <Link className="item" to="/admin/candidats" style={{ textDecoration: "none" }}>
            <div className="p-2">
              <div className="itemTitle">{t('applications')}</div>
              <div className="itemResult positive">
                <div className="amount">{candidates.length}</div>
              </div>
            </div>
          </Link>
          <Link className="item" to="/admin/posts" style={{ textDecoration: "none" }}>
            <div className="p-2">
              <div className="itemTitle">{t('posts')}</div>
              <div className="itemResult positive">
                <div className="amount">{posts.length}</div>
              </div>
            </div>
          </Link>
          {
            type === 'admin' ?
              <Link className="item" to="/admin/examinators" style={{ textDecoration: "none" }}>
                <div className="p-2">
                  <div className="itemTitle">{t('examinators')}</div>
                  <div className="itemResult positive">
                    <div className="amount">{examinators.length}</div>
                  </div>
                </div>
              </Link>
          :
            <></>
          }
        </div>
      </div>
    </div>
  );
};

export default Featured;
